import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';
import { EColor, EIcon, ERouting, ESize, ETypographyVariant } from '@core/type';

import { LinkTranslatedStyledAsLink } from '../link-translated/LinkTranslatedStyledAsLink';

export const LinkChange = ({ keyRoute }: { keyRoute: ERouting }) => {
  const { t } = useTranslation(Translate.common.BUTTON);

  return (
    <LinkTranslatedStyledAsLink
      keyRoute={keyRoute}
      variant={ETypographyVariant.BODY3}
      color={EColor.SECONDARY}
      endIcon={EIcon.EDIT}
      iconSize={ESize.SM}
    >
      {t('change.title')}
    </LinkTranslatedStyledAsLink>
  );
};
